import { render } from "./ListUserGroups.vue?vue&type=template&id=147ea68e"
import script from "./ListUserGroups.vue?vue&type=script&lang=js"
export * from "./ListUserGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__